module.exports = __webpack_public_path__ + "c5bc68beaa268b82c7dcc0e9efe15a9b.woff";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/National2Web-Light.woff
// module id = 2511
// module chunks = 17